<template lang="pug">
.c-contact.c-whdForm
  .c-contact__block
    .c-contact__form(style="width:100%; min-width:auto; max-width: none;")
      form(@submit.prevent.stop="onSubmit")
        q-input(outlined ref="firstName" v-model="contact.firstName" :label="contact.text.firstName" square :dense="true" style="margin-bottom: 5px" color="primary" :error-message="contact.text.firstNameError" lazy-rules :rules="[ val => val && val.length > 0]" no-error-icon)
        q-input(outlined ref="lastName" v-model="contact.lastName" :label="contact.text.lastName" square :dense="true" style="margin-bottom: 5px" color="primary" :error-message="contact.text.lastNameError" lazy-rules :rules="[ val => val && val.length > 0]" no-error-icon)
        //- q-input(outlined ref="company" v-model="contact.company" :label="contact.text.company" square :dense="true" style="margin-bottom: 5px" color="primary" :error-message="contact.text.companyError" lazy-rules :rules="[ val => val && val.length > 0]" no-error-icon)
        q-input(outlined ref="phone" v-model="contact.phone" :label="contact.text.phone" square :dense="true"  style="margin-bottom: 5px" color="primary" :error-message="contact.text.phoneError" lazy-rules :rules="[ val => val && val.length > 0]" no-error-icon)
        q-input(outlined ref="email" v-model="contact.email" :label="contact.text.email" square :dense="true" style="margin-bottom: 5px" color="primary" :error-message="contact.text.emailError" lazy-rules :rules="[ val => val && val.length > 0 && /^[A-Za-z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val)]" no-error-icon)
        q-input(outlined ref="remark" v-model="contact.remark" :label="contact.text.remark" square :dense="true" type="textarea" style="margin-bottom: 20px; resize: none;" color="primary")
        //- q-btn.c-contact__form--btn(type='submit' outline style="background-color:rgba(255,255,255,.4)!important; color: rgba(255, 255, 255, 0.6); margin: 10px 0; display:block; width:100%; border-radius:3px;" :label="contact.text.submit")
        button.c-whdButton(type="submit") {{ contact.text.send }}
      p.submitMsg
        span.submitMsg__success(v-if="submitMsg=='1'") {{ contact.text.submitSuccess }}
        span.submitMsg__fail(v-else-if= "submitMsg=='2'") {{ contact.text.submitFail }}

</template>

<script>
  import api from '@/api'

  export default {
    name: 'contactForm',
    components: {
      'q-input': Quasar.QInput,
    },
    data(){
      return{
        contact:{
          firstName: "",
          lastName: "",
          // company: "",
          phone: "",
          email: "",
          remark: "",
          text:{
            firstName: this.$t('contact_form.firstName'),
            lastName: this.$t('contact_form.lastName'),
            // company: this.$t('contact_form.company'),
            phone: this.$t('contact_form.phone'),
            email: this.$t('contact_form.email'),
            remark: this.$t('contact_form.remark'),
            submit: this.$t('contact_form.submit'),
            send: this.$t('contact_form.send'),
            firstNameError: this.$t('contact_form.first_name_error'),
            lastNameError: this.$t('contact_form.last_name_error'),
            companyError: this.$t('contact_form.company_error'),
            phoneError: this.$t('contact_form.phone_error'),
            emailError: this.$t('contact_form.email_error'),
            submitSuccess: this.$t('contact_form.submit_success'),
            submitFail: this.$t('contact_form.submit_fail')
          }
        },
        submitMsg: '0'
      }
    },
    computed: {},
    methods:{
      onSubmit(){
        this.submitMsg = '0'
        this.$refs.firstName.validate()
        this.$refs.lastName.validate()
        // this.$refs.company.validate()
        this.$refs.phone.validate()
        this.$refs.email.validate()
        if (this.$refs.firstName.hasError || this.$refs.lastName.hasError || this.$refs.phone.hasError || this.$refs.email.hasError) {
          this.formHasError = true
        } else {
          let html = `<html><body>`
          html += `<p><span>First Name:</span><span>${this.contact.firstName}</span></p>`
          html += `<p><span>Last Name:</span><span>${this.contact.lastName}</span></p>`
          html += `<p><span>Phone:</span><span>${this.contact.phone}</span></p>`
          html += `<p><span>Email:</span><span>${this.contact.email}</span></p>`
          html += `<p><span>Remark:</span><span>${this.contact.remark}</span></p>`
          html += `</body></html>`

          api.sendEmail(html, data => {
            if(data.code == 0) {
              this.contact.firstName = null
              this.contact.lastName = null
              this.contact.phone = null
              this.contact.email = null
              this.contact.remark = null
              this.$refs.firstName.resetValidation()
              this.$refs.lastName.resetValidation()
              this.$refs.phone.resetValidation()
              this.$refs.email.resetValidation()
              this.submitMsg = '1'
            }else{
              this.submitMsg = '2'
            }
          },error=>{
            this.submitMsg = '2'
          })
        }
      },
    },
    created(){}
  }
</script>

<style>
  .submitMsg{
    line-height: 2em;
    min-height: 28px;
    position: relative;
    z-index: 1;
  }
  .submitMsg__success{
    color: white;
  }
  .submitMsg__fail, .q-field--error .q-field__bottom, .text-negative{
    color: #ff5555 !important;
  }
</style>
